import {readable, writable} from 'svelte/store';
import {getTblParam, replaceMask} from "./table-store.js";


////////////////////////////////////

export const menuStore = writable({});
export const menuRecordsCountStore = writable(0);

function initMenuStore() {
    const menu = JSON.parse(JSON.stringify(M.menu));

    // preparation
    const tableParam = getTblParam();
    let recordsCount = 0;
    (menu.sections || []).forEach(s => {

        recordsCount += (s?.records || []).length;

        (s?.records || []).forEach(r => {

            // set default selected price of mod if it has not
            if (r.prices && r.prices.length > 1) {
                const hasSelected = r.prices.find(o => o.selected) !== undefined;
                if (!hasSelected) {
                    r.prices[0].selected = true;
                }
            }
        });

        if (s.sectionType === 'text-block' && s.textBlock?.buttons?.length > 0) {
            s.textBlock?.buttons.forEach(x => {
                x.link = replaceMask(x.link, tableParam);
            });
        }
    });

    menuStore.update(x => menu);
    menuRecordsCountStore.update(x => recordsCount);
}

initMenuStore();

export const isPaidStore = readable(
    {},
    (set) => {
        set (M.paid);
        return () => {}
    });

export const mediaUrlStore = readable(
    {},
    (set) => {

        M.mediaUrl = M.mediaUrl || 'https://patico-qr-test.s3.eu-west-3.amazonaws.com';

        if (!M.mediaUrl.endsWith('/')) {
            M.mediaUrl = M.mediaUrl +  '/';
        }

        set (M.mediaUrl);
        return () => {}
    });

export const publishConfigStore = readable(
    {},
    (set) => {

        const publishConfig = M.publishConfig;

        if (!publishConfig.headerActions) {
            publishConfig.headerActions = [];
        }

        if (publishConfig.restaurantPhones) {
            const callable = publishConfig.restaurantPhone && publishConfig.restaurantPhoneCode !== 'none';
            publishConfig.headerActions.push({
                text: publishConfig.restaurantPhones,
                icon: callable ? 'phone' : undefined,
                link: callable ? `tel:${publishConfig.restaurantPhoneCode || ''}${publishConfig.restaurantPhone}` : undefined,
                target: callable ? `` : '_blank'
            });

            // publishConfig.restaurantPhones = undefined; //clear
        }

        set (publishConfig);
        return () => {}
    });

export const tenantKeyStore = readable(
    {},
    (set) => {
        set (M.tenantKey);
        return () => {}
    });

/**
 *
 * @type {Readable<{showMealTitleAtFrontPage: boolean}>}
 */
export const optionsStore = readable(
    {},
    (set) => {
        set ({
                showMealTitleAtFrontPage: true
            });
        return () => {}
    });


////////////////////////////////////


export const filtersStore = writable({
    favorites: false,
    allergens: [],
    searchText: undefined
});

export const filterAllergens = (event) => {
    filtersStore.update(x => {
        x.allergens = event?.detail?.hide || [];
        return x;
    });
}

export const filterFavorites = () => {
    filtersStore.update(x => {
        x.favorites = !x.favorites;
        return x;
    });
}

export const resetFilterFavorites = () => {
    filtersStore.update(x => {
        x.favorites = false;
        return x;
    });
}

export const searchFilter = (searchText) => {
    filtersStore.update(x => {
        x.searchText = searchText;
        return x;
    });
}


////////////////////////////////////

export const favsStore = writable([]);

export const loadFavorites = () => {
    try {
        const favs = JSON.parse(window.localStorage.getItem('favoritesList')) || [];
        favsStore.set(favs);
        return favs;
    }
    catch (e) { return []; }
}

export const toggleFavorite = (event) => {

    if (event.detail.isFavorite) {

        favsStore.update(list => {

            list.push(event.detail.recordId);
            list = [...new Set(list)]; // uniq only
            window.localStorage.setItem('favoritesList', JSON.stringify(list));

            return list;
        });
    }
    else {
        favsStore.update(list => {
            list = [...list.filter(x => x !== event.detail.recordId)];
            window.localStorage.setItem('favoritesList', JSON.stringify(list));

            return list;
        });
    }
}
